import * as React from 'react';

import SocialStudiesSubjectPage from '../../../containers/SocialStudiesSubjectPage';
import AssignmentFlowNavigation from '../assignment_flow_navigation';
import { getPageTitle } from '../../../../Shared';

const AssignSocialStudiesSubjectPage = () => {
  document.title = getPageTitle("Assign", "Social Studies")
  return (
    <div>
      <AssignmentFlowNavigation />
      <SocialStudiesSubjectPage />
    </div>
  )
}

export default AssignSocialStudiesSubjectPage
